import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import Information from "rialto-icons/Information";

import styles from "./Modal.css";

const ModalBody = ({ children, className, isInfo }) => {
  if (!children) return null;

  return (
    <div
      className={classnames(styles.block, styles.body, className, {
        [styles.info]: isInfo,
      })}
    >
      {isInfo && <Information />}
      {children}
    </div>
  );
};

ModalBody.propTypes = {
  children: PropTypes.node,
  isInfo: PropTypes.bool,
  className: PropTypes.string,
};

export default ModalBody;
